<script>
  export let category
  export let creators
  export let credit

  $: creditString = [
    (category || 'Foto').concat(':'),
    creators && creators.join(', '),
    creators && credit && '/',
    credit,
  ]
    .filter((value) => value)
    .join(' ')
</script>

<div class="credit">{creditString}</div>

<style>
  .credit {
    font-size: 12px;
    text-align: right;
  }
</style>
